var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page wrapper', {}],attrs:{"id":"checkout"}},[_c('the-header'),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('contact')],1),_c('div',{staticClass:"column"},[_c('fees')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }